import { render, staticRenderFns } from "./AuthCard.vue?vue&type=template&id=9ead3b8c&"
import script from "./AuthCard.vue?vue&type=script&lang=ts&"
export * from "./AuthCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports